export default "__VITE_ASSET__DPctf5SW__"